import { Mission } from '../mission/mission';
import { OverlappingResponse } from './overlapping-response';

export class ErrorResponse {
	status: number;
	error: { response: string };
	url: string;
}

export class ErrorResponseWithMissionBody {
	status: number;
	error: OverlappingResponse[];
	url: string;
}
